import LoginEmail from "./Email";
import Heading from "@/components/Elements/Heading";
import React from "react";
import { AuthenticationContext } from "../Wrapper";
import BankIdChooseAccount from "./BankIdChooseAccount";
import BankIdWrapper from "@/components/BankId";
import ArrowButton from "@/components/Elements/ArrowButton";
import Link from "next/link";
import useModalStore from "@/hooks/useModalStore";

const CONTACT_URL = "/om-oss/kontakt";

const LoginWrapper: React.FC = () => {
  const { state, dispatch } = React.useContext(AuthenticationContext);
  const { loginModal } = useModalStore();

  const loginMethod = state?.loginMethod;

  const closeModal = () => {
    if (state.isLoginModal) loginModal.onClose();
  };

  const createAccount = state.isLoginModal ? (
    <Link href="/mina-sidor/?skapa-konto" className="!no-underline">
      <ArrowButton text="Skapa konto" direction="right" onClick={closeModal} />
    </Link>
  ) : (
    <ArrowButton
      extraClasses="text-lg md:text-base"
      text="Skapa konto"
      direction="right"
      onClick={() => dispatch({ type: "SET_SHOW", payload: "register" })}
    />
  );

  const contactUs = (
    <Link href={CONTACT_URL} className="!no-underline">
      <ArrowButton
        text="Kontakta Toveks Auktioner"
        direction="right"
        onClick={closeModal}
      />
    </Link>
  );

  return (
    <div className="w-full">
      {!state.hideTitles && (
        <Heading size="lg" className="mb-6">
          {state.loginTitle || "Logga in"}{" "}
        </Heading>
      )}
      <div className="flex flex-col">
        <div className="self-stretch flex flex-row items-start justify-start">
          <div className="flex-1 relative leading-[150%]">
            {loginMethod === "email" ? (
              <LoginEmail />
            ) : (
              <BankIdWrapper
                bankIdOptions={{
                  setBankIDSecret: true,
                }}
                successComponent={BankIdChooseAccount}
                bankIdTitle="Vid inloggning med Mobilt BankID på annan enhet."
                bankIdDescription="På grund av säkerhetsskäl har du 30 sekunder på dig att läsa av
              QR-koden."
              />
            )}
          </div>
        </div>

        <div className="flex flex-col mt-6 space-y-6 md:mt-8 bg-aliceblue p-5 text-toast-blue rounded-lg">
          <div className="flex flex-col space-y-2">
            Har du inget konto?
            {createAccount}
          </div>
          {loginMethod === "email" ? (
            <div className="flex flex-col space-y-2">
              Kan du inte logga in med Bank-ID?
              {contactUs}
            </div>
          ) : (
            <>
              <div className="flex flex-col space-y-2">
                Har du inget Bank-ID?
                {contactUs}
              </div>
              <div className="flex flex-col space-y-2">
                Don&apos;t have a swedish personal number?
                <ArrowButton
                  text="Login via username"
                  direction="right"
                  onClick={() =>
                    dispatch({ type: "SET_LOGIN_METHOD", payload: "email" })
                  }
                />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginWrapper;
